// upstack_api's Engagements::FunctionalityMatrix refuses anything past these, so the inputs stop there first.
export const MATRIX_NAME_LIMIT = 200;
export const MATRIX_DESCRIPTION_LIMIT = 1000;
export const MATRIX_NEW_FEATURES_LIMIT = 50;
